import { VisualStyleId } from "../constants/visualStyles";

export interface IdeaGenerationSettings {
  brandKitId: string | null;
  connectionIds: string[];
  templateIds: string[];
  visualStyleId: VisualStyleId;
}

export interface IdeaGenerationPreset {
  sourceBrandKitId: string | null;
  settings: IdeaGenerationSettings;
}


export interface SourceGenerationPresets {
  // Shared choices from the last confirmed generation, across post types.
  generationPreset?: IdeaGenerationPreset;
  // Template choices stay specific to the post type; also supports older sources.
  generationPresets?: Partial<Record<"listicle" | "quote", IdeaGenerationPreset>>;
}

export function resolveIdeaGenerationSettings(
  source: SourceGenerationPresets | undefined,
  category: "listicle" | "quote",
  sourceBrandKitId: string | null,
): IdeaGenerationSettings | undefined {
  const matching = (preset?: IdeaGenerationPreset) =>
    preset?.sourceBrandKitId === sourceBrandKitId ? preset : undefined;
  const categoryPreset = matching(source?.generationPresets?.[category]);
  const latest = source?.generationPreset
    ? matching(source.generationPreset)
    : categoryPreset ?? matching(source?.generationPresets?.listicle) ?? matching(source?.generationPresets?.quote);
  if (!latest) return undefined;
  return {
    ...latest.settings,
    templateIds: categoryPreset?.settings.brandKitId === latest.settings.brandKitId
      ? categoryPreset.settings.templateIds
      : [],
  };
}

export interface AutopilotConfig {
  userId: string;
  enabled: boolean;
  connectionIds: string[];
  brandKitId?: string;
  targetLanguage?: string;
  contentIntent?: string;
  digestUnsubscribedAt?: number | null;
  /** Set by the server when the workspace last used Check now. */
  lastManualCheckAt?: number;
}
